const React = require('react');
const isNode = (typeof process !== 'undefined');
const {Collapse} = isNode ? require('react-collapse') : () => null;
const presets = isNode ? require('react-motion') : () => {};

class Faq extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: []
        };
        this.toggleQuestion = this.toggleQuestion.bind(this);
    }

    toggleQuestion(i) {
        const {open} = this.state;
        const index = open.indexOf(i);

        if (index > -1) {
            delete open[index];
            this.setState({
                open: open
            });
        } else {
            this.setState({
                open: this.state.open.concat(i)
            });
        }
    }

    render() {
        const {title, faqs} = this.props;
        const {open} = this.state;
        return (
        <section className="faq">
            <div className="faq__container">
                <h2 className="faq__title">{title}</h2>
                {faqs.map((faq, i) => {
                    const isOpen = open.indexOf(i) > -1;
                    return (
                    <div className="faq__qa">
                        <h3 className="faq__question" onClick={() => this.toggleQuestion(i)}>
                            {faq.displayName}
                            <svg className={'faq__arrow' + (isOpen ? ' faq__arrow--open' : '')} x="0px" y="0px" viewBox="0 0 960 560">
                                <g>
                                    <path d="M480,344.181L268.869,131.889c-15.756-15.859-41.3-15.859-57.054,0c-15.754,15.857-15.754,41.57,0,57.431l237.632,238.937
                                        c8.395,8.451,19.562,12.254,30.553,11.698c10.993,0.556,22.159-3.247,30.555-11.698l237.631-238.937
                                        c15.756-15.86,15.756-41.571,0-57.431s-41.299-15.859-57.051,0L480,344.181z"/>
                                </g>
                            </svg>
                        </h3>
                        {isNode ? (
                        <Collapse isOpened={isOpen} springConfig={presets.stiff}>
                            <div className="faq__answer">
                                <div dangerouslySetInnerHTML={{__html: faq.data.answer}}/>
                            </div>
                        </Collapse>
                        ) : (
                        <div className="faq__answer">
                            <div dangerouslySetInnerHTML={{__html: faq.data.answer}}/>
                        </div>
                        )}
                    </div>
                    )
                })}
            </div>
        </section>
        )
    }
}

module.exports = Faq;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/faq/Component/index.jsx